/* eslint-disable react/no-danger */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { ButtonType } from 'src/enums/ButtonType'
import Image from 'next/image'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import styles from './illogicalFlowOverlay.module.scss'
import { Button, type ButtonProps } from '../AutoWidgetButton/button'

interface IconProps {
  src: string
  alt: string
}

interface IllogicalFlowOverlayProps {
  regNo: string
  icon?: IconProps
  heading: string
  subHeading?: string
  primaryCta: ButtonProps
  secondaryCta?: ButtonProps
  onClose: Function
  onCloseCtaSegmentEventName?: string
  onCloseCtaSegmentEventProps?: object
}

const IllogicalFlowOverlay = ({
  regNo,
  icon,
  heading,
  subHeading,
  primaryCta,
  secondaryCta,
  onClose,
  onCloseCtaSegmentEventName,
  onCloseCtaSegmentEventProps,
}: IllogicalFlowOverlayProps) => (
  <div className={styles.illogicalFlowRootContainer}>
    <div className={styles.illogicalFlowOverlayContainer}>
      <Image
        className={styles.illogicalFlowCrossIcon}
        src="https://acko-cms.ackoassets.com/Close_cross_6b419a9bac.svg"
        alt="Cross icon"
        width={24}
        height={24}
        onClick={() => {
          trackEvent(onCloseCtaSegmentEventName, { ...onCloseCtaSegmentEventProps })
          onClose()
        }}
      />
      <div className={styles.illogicalFlowOverlayDetails}>
        <div className={styles.illogicalFlowOverlayHeader}>
          {icon?.src ? (
            <Image
              src={icon?.src}
              alt={icon?.alt || ''}
              className={styles.illogicalFlowOverlayIcon}
              width={0}
              height={0}
            />
          ) : null}
          <div className={styles.illogicalFlowRegNoContainer}>{regNo}</div>
        </div>
        <div className={styles.illogicalFlowOverlayInfo}>
          <div className={styles.illogicalFlowHeading}>{heading}</div>
          <div className={styles.illogicalFlowSubHeading}>{subHeading}</div>
        </div>
      </div>
      <div className={styles.illogicalFlowCtaContainer}>
        {secondaryCta ? <Button type={ButtonType.White} {...secondaryCta} /> : null}
        <Button type={ButtonType.Green} {...primaryCta} />
      </div>
    </div>
  </div>
)

export default IllogicalFlowOverlay
